var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import omit from 'lodash/omit';
import classNames from 'classnames';

import './Menu.scss';

var MENU_ITEM_SELECTOR = '.menu-item:not([aria-disabled])';
var TOP_LEVEL_MENU_ITEM_SELECTOR = 'ul:not(.submenu) > ' + MENU_ITEM_SELECTOR + ', ul:not(.submenu) > li > ' + MENU_ITEM_SELECTOR;
var SUBMENU_ITEM_SELECTOR = 'ul.submenu > ' + MENU_ITEM_SELECTOR + ', ul.submenu > li > ' + MENU_ITEM_SELECTOR;

function stopPropagationAndPreventDefault(event) {
    event.stopPropagation();
    event.preventDefault();
}

var Menu = function (_React$Component) {
    _inherits(Menu, _React$Component);

    function Menu(props) {
        _classCallCheck(this, Menu);

        var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));

        _initialiseProps.call(_this);

        _this.menuEl = null;
        _this.focusIndex = 0;
        _this.menuItemEls = [];
        return _this;
    }

    _createClass(Menu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setInitialFocusIndex();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isSubmenu && !nextProps.isHidden && this.props.isHidden) {
                // If updating submenu, use the upcoming props instead of current props.
                this.setInitialFocusIndex(nextProps);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            // update focus index and menu item elements when the number of children changes
            if (React.Children.toArray(prevProps.children).length !== React.Children.toArray(this.props.children).length) {
                var focusedMenuItemEl = this.menuItemEls[this.focusIndex];
                this.setMenuItemEls();

                var _getMenuItemElFromEve = this.getMenuItemElFromEventTarget(focusedMenuItemEl),
                    menuIndex = _getMenuItemElFromEve.menuIndex;

                this.setFocus(menuIndex);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                children = _props.children,
                className = _props.className,
                isHidden = _props.isHidden,
                setRef = _props.setRef,
                shouldOutlineFocus = _props.shouldOutlineFocus,
                rest = _objectWithoutProperties(_props, ['children', 'className', 'isHidden', 'setRef', 'shouldOutlineFocus']);

            var menuProps = omit(rest, ['onClose', 'initialFocusIndex', 'isSubmenu']);
            menuProps.className = classNames('aria-menu', className, {
                'is-hidden': isHidden,
                'should-outline-focus': shouldOutlineFocus
            });
            menuProps.ref = function (ref) {
                _this2.menuEl = ref;
                if (setRef) {
                    setRef(ref);
                }
            };
            menuProps.role = 'menu';
            menuProps.tabIndex = -1;
            menuProps.onClick = this.handleClick;
            menuProps.onKeyDown = this.handleKeyDown;

            return React.createElement(
                'ul',
                menuProps,
                children
            );
        }
    }]);

    return Menu;
}(React.Component);

Menu.defaultProps = {
    className: '',
    isSubmenu: false,
    isHidden: false
};
Menu.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string.isRequired,

    /** Focuses a specific menu item index when menu is mounted */
    initialFocusIndex: PropTypes.number,
    isSubmenu: PropTypes.bool,
    isHidden: PropTypes.bool,
    shouldOutlineFocus: PropTypes.bool,

    /** Will fire this callback when menu should "close' */
    onClose: PropTypes.func,
    setRef: PropTypes.func
};

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.setInitialFocusIndex = function (props) {
        if (!props) {
            props = _this3.props;
        }
        var _props2 = props,
            initialFocusIndex = _props2.initialFocusIndex;


        _this3.setMenuItemEls();

        // If an initialFocusIndex was specified, attempt to use it to focus
        if (typeof initialFocusIndex === 'number') {
            // We do this after a timeout so that the menu is properly mounted before we attempt to focus it
            setTimeout(function () {
                _this3.setFocus(initialFocusIndex);
            }, 0);
        } else if (initialFocusIndex === null) {
            // If no initial focus index is set, focus on the menu itself so that keyboard shortcut still works after a mouse click.
            setTimeout(function () {
                if (_this3.menuEl) {
                    _this3.menuEl.focus();
                }
            }, 0);
        }
    };

    this.setMenuItemEls = function () {
        var isSubmenu = _this3.props.isSubmenu;


        var selector = isSubmenu ? SUBMENU_ITEM_SELECTOR : TOP_LEVEL_MENU_ITEM_SELECTOR;
        // Keep track of all the valid menu items that were rendered (querySelector since we don't want to pass ref functions to every single child)
        _this3.menuItemEls = _this3.menuEl ? [].slice.call(_this3.menuEl.querySelectorAll(selector)) : [];
    };

    this.getMenuItemElFromEventTarget = function (target) {
        var menuItemEl = null;
        var menuIndex = -1;

        for (var i = 0; i < _this3.menuItemEls.length; i++) {
            if (_this3.menuItemEls[i].contains(target)) {
                menuItemEl = _this3.menuItemEls[i];
                menuIndex = i;
                break;
            }
        }
        return { menuItemEl: menuItemEl, menuIndex: menuIndex };
    };

    this.setFocus = function (index) {
        if (!_this3.menuItemEls.length) {
            return;
        }

        var numMenuItems = _this3.menuItemEls.length;

        if (index >= numMenuItems) {
            _this3.focusIndex = 0;
        } else if (index < 0) {
            _this3.focusIndex = numMenuItems - 1;
        } else {
            _this3.focusIndex = index;
        }

        _this3.menuItemEls[_this3.focusIndex].focus();
    };

    this.focusFirstItem = function () {
        _this3.setFocus(0);
    };

    this.focusLastItem = function () {
        _this3.setFocus(-1);
    };

    this.focusNextItem = function () {
        _this3.setFocus(_this3.focusIndex + 1);
    };

    this.focusPreviousItem = function () {
        _this3.setFocus(_this3.focusIndex - 1);
    };

    this.fireOnCloseHandler = function (isKeyboardEvent) {
        var onClose = _this3.props.onClose;


        if (onClose) {
            // We need to pass the event type so we know which item to focus.
            onClose(isKeyboardEvent);
        }
    };

    this.handleClick = function (event) {
        var _ref = event.target instanceof Node ? _this3.getMenuItemElFromEventTarget(event.target) : {},
            menuItemEl = _ref.menuItemEl;

        if (!menuItemEl) {
            return;
        }

        _this3.fireOnCloseHandler(false);
    };

    this.handleKeyDown = function (event) {
        var _props3 = _this3.props,
            isSubmenu = _props3.isSubmenu,
            initialFocusIndex = _props3.initialFocusIndex;


        switch (event.key) {
            case 'ArrowDown':
                stopPropagationAndPreventDefault(event);

                // If it's first keyboard event, focus on first item.
                if (initialFocusIndex === null && !_this3.keyboardPressed) {
                    _this3.focusFirstItem();
                } else {
                    _this3.focusNextItem();
                }

                break;

            case 'ArrowUp':
                stopPropagationAndPreventDefault(event);

                _this3.focusPreviousItem();
                break;

            case 'ArrowLeft':
                // Close submenu when arrow-left is clicked
                if (!isSubmenu) {
                    return;
                }
                stopPropagationAndPreventDefault(event);
                _this3.fireOnCloseHandler(true);
                break;

            case 'Home':
            case 'PageUp':
                stopPropagationAndPreventDefault(event);

                _this3.focusFirstItem();
                break;

            case 'End':
            case 'PageDown':
                stopPropagationAndPreventDefault(event);

                _this3.focusLastItem();
                break;

            case 'Escape':
                stopPropagationAndPreventDefault(event);

                _this3.fireOnCloseHandler(true);
                break;

            case 'Tab':
                // DO NOT PREVENT DEFAULT OR STOP PROPAGATION - This should move focus natively
                _this3.fireOnCloseHandler(true);
                break;

            case ' ': // Spacebar
            case 'Enter':
                stopPropagationAndPreventDefault(event);

                if (event.target instanceof HTMLElement) {
                    event.target.click();
                }
                break;

            default:
                break;
        }

        _this3.keyboardPressed = true;
    };
};

export default Menu;
import PropTypes from 'prop-types';